import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'smartCurrencyText'
})
export class SmartCurrencyTextPipe implements PipeTransform {

  transform(value: string): string {

    if (!value) {
      return value;
    }

    return value.replace(
      /\b(Rp\s*)?(\d{4,})\b/gi,
      (_, prefix, number) => {

        const formatted = Number(number)
          .toLocaleString('id-ID');

        return prefix
          ? `Rp ${formatted}`
          : formatted;
      }
    );
  }
}